import React, {Component} from 'react';
import axios from 'axios';
import Moment from 'react-moment';
import 'moment/locale/es';
import moment from "moment";
import fileDownload from 'js-file-download';
import * as ReactBootStrap from 'react-bootstrap';
import '../tools/css/Agendas.css';
import '../tools/css/Home.css';
import '../tools/css/Iframe.css';
import Profesionales from '../API/Profesionales';
import DiasSemana from '../API/DiasSemana';
import BtnEdit from '../components/BtnEdit';
import BtnVer from '../components/BtnVer';
import cargamultimedia from '../tools/images/iconocargarfoto.svg'
import Logo_nuevo from '../tools/images/Nuevo';
import Info from '../tools/images/Info';
import Logo_agenda from '../tools/images/Agenda';
import BtnAdd from '../components/BtnAdd';
import BtnDelete from '../components/BtnDelete';
import emptypage from '../tools/images/carpeta.gif';
import Buscar from '../tools/images/Buscar';
import file_pdf from '../tools/images/file_arrow.svg';
import Select from 'react-select';

import ReactNotifications from 'react-notifications-component';
import { store } from 'react-notifications-component';
import 'animate.css';
import 'react-notifications-component/dist/theme.css';

import $ from 'jquery'; // <-to import jquery
import 'bootstrap';

const ApiURL="https://medicall-api-test.azurewebsites.net";
var institution_id =sessionStorage.getItem('id_institution');
var token_profesional =sessionStorage.getItem('token_profesional');
var token_institucion =sessionStorage.getItem('token');
var id_med_anexo =sessionStorage.getItem('identificacion_profesional');
var id_profe=sessionStorage.getItem('codigo_med');
var nom_med_anexo =sessionStorage.getItem('nombre_usua');
var url_iframe="https://acsc.appideas.com.co/agenda-profesional?token="+token_profesional+"&idProfesional="+id_profe+"&identificacion="+id_med_anexo+"&tokenInstitucion="+token_institucion+"&idInstitucion="+institution_id
var mensaje='';

var id_especialidad='0';
var id_sede='0';
var id_sededit='0'
var nom_sededit='';
var id_especialidad_edit='0';
var dia_intervalo='null';
var agendaid='0';
var nom_agenda='';
var buscar_agenda='';
var buscar_agenda_inactiva='';
var buscar_agenda_vencida='';
var buscar_agenda_anulada='';
var dato=0;
var btn_activar='';
var estado_agenta='';
var est_agenda='';
var id_tipo_servi=0;
var id_cita_cancela=0;
var tipo_filtro='';
var tipo_filtro_atendidos='';
var buscar_solicitada='';
var id_consulta=0;
var diagnosticos_pcte=[];
var avatar=[];
var nombre_tipoanexo="";
var file_base64_doc="";
var id_tipoanexo="0";
var id_anexo_elimina=0



class Agendas_profesional extends Component {

  constructor()
    {
     super()
      this.state={
        Horario: [], 
        Parametro:[],
        Agendas: [],         
        Pager_Agendas: [],
        pager_infoagendas:'', 
        Agendas_inactivas: [],         
        Pager_Agendas_inactivas: [],
        pager_infoagendas_inactivas:'', 
        Agendas_vencidas: [],         
        Pager_Agendas_vencidas: [],
        pager_infoagendas_vencidas:'',
        Agendas_anulada: [],         
        Pager_Agendas_anulada: [],
        Diagnotico_Multiple:[],
        Diagnotico_Multiple_edit:[],
        Diagnostico_hc:[],
        pager_infoagendas_anulada:'',
        loading: false,
        Sedes:[] ,
        profesionales: [],
        IntervaloAgenda: [],
        Especialidades:[],
        Servicios: [],
        Tipo_anexos:[],
        Historia:[],
        Historial_anexos:[],
        loading_button: true,
        active_button: true,
        loading_button_cancelacita: true,
        active_button_cancelacita: true,
        active: true,
        loading_button_intervalo: true,
        active_button_intervalo: true,
        loading_button_eliminar: true,
        active_button_eliminar: true,
        loading_btnaddanexo: true,
        active_btnaddanexo: true,
        loading_btnhisanexo: true,
        active_btnhisanexo: true,
        loading_button_eliminaanexo:true,
        active_button_eliminaanexo:true,
        active_check:true,
        form:{ 
          nom_agenda: '',         
          fecha_ini:'',
          fecha_fin:'',
          id_agenda_edit:'',
          nom_agenda_edit:'',
          fechaini_edit:new Date,
          fechafin_edit:new Date,
          inicio:'',
          fin:'',
          intervalo:'',
          espe:'0',
          buscar_agendas:'',
          buscar_agendas_inactiva:'',

          id_cita:'',
          id_pacie_soli:'',
          tipoid_pacien_hc:'',
          id_pacien_hc:'',
          nom1_pacien:'',
          nom2_pacien:'',
          apell1_pacien:'',
          apell2_pacien:'',
          obser:'',
          fecha_cita:'',
              
          espe_soli:'',
              
          fecha_naci:'',
          edad_pcte:'',
          genero_pcte:'',
          dir_pcte:'',
          tel_pcte:'',
          municipio_pcte:'',
          departamento_pct: '',
          responsable_pcte:'',
          telresponsable_pcte:'',
          parentescoresp_pcte:'',
          eps_pcte:'',
          regimen_pcte:'',
          email_pcte:'', 
          
          idconsulta:'',
          id_paciente:'',
          nom_pctehc:'',
          eps:'',

          acompanante:'',
          tel_acompanante:'',
          motivo_consulta:'',
          enfermada_actual:'',
          antecedentes_rel:'',
          revision_sistema:'',
          examen_fis:'',
          analisis:'',
          conducta:'',
          formula_med:'',
          orden_med:'',

          nombre_anexo:'',
          descripcion_anexo:'',
          num_file:'Ningún archivo seleccionado'
          

          }
      }
    }



    render(){ 
      
      const {form} = this.state;

     return (
     
          <div className="content-wrapper">

                    <div className="m24-iframe-fill">
                      <iframe
                        title="Agenda"
                        src={url_iframe}
                        loading="lazy"
                        allowFullScreen
                        >
                      </iframe>
                    </div>

          </div>
      
    )

  }
  
}

export default Agendas_profesional;